import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Flex from "components/Flex";

const useStyles = makeStyles((theme) => ({
  inputPicker: {
    borderRadius: "8px",
    backgroundColor: "#ffffff",
    width: "140px",
    height: "42px",
    "& input": {
      fontSize: "14px",
      padding: "8px",
      height: "42px"
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      height: "42px",
      "&:hover fieldset": {
        borderColor: "rgba(51, 51, 51, 0.5)"
      },
      "&.Mui-focused fieldset": {
        borderColor: "rgba(51, 51, 51, 0.5)",
        borderWidth: "1px"
      },
      "& fieldset": {
        borderColor: "rgba(51, 51, 51, 0.3)",
        borderWidth: "1px"
      }
    }
  },
  datePickerContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0px",
    marginRight: 0
  }
}));

const CustomDateRangePicker = ({
  control,
  name,
  defaultValue,
  rules,
  title1,
  title2,
  onDateChange
}) => {
  const classes = useStyles();
  const [startDate, setStartDate] = useState(defaultValue[0]);
  const [endDate, setEndDate] = useState(defaultValue[1]);

  useEffect(() => {
    setStartDate(defaultValue[0]);
    setEndDate(defaultValue[1]);
  }, [defaultValue]);

  const handleStartDateChange = (event) => {
    const newStartDate = event.target.value;
    setStartDate(newStartDate);
    onDateChange(newStartDate, endDate);
  };

  const handleEndDateChange = (event) => {
    const newEndDate = event.target.value;
    setEndDate(newEndDate);
    onDateChange(startDate, newEndDate);
  };

  return (
    <Flex align="center" className={classes.datePickerContainer}>
      {title1}
      <Controller
        name={`${name}.start`}
        control={control}
        defaultValue={startDate}
        rules={rules}
        render={({ field }) => (
          <TextField
            {...field}
            type="date"
            value={startDate}
            onChange={(e) => {
              handleStartDateChange(e);
              field.onChange(e.target.value); 
            }}
            className={classes.inputPicker}
            variant="outlined"
          />
        )}
      />
      {title2}
      <Controller
        name={`${name}.end`}
        control={control}
        defaultValue={endDate}
        rules={rules}
        render={({ field }) => (
          <TextField
            {...field}
            type="date"
            value={endDate}
            onChange={(e) => {
              handleEndDateChange(e);
              field.onChange(e.target.value); 
            }}
            className={classes.inputPicker}
            variant="outlined"
          />
        )}
      />
    </Flex>
  );
};

export default CustomDateRangePicker;
